import { render } from "./HomeView.vue?vue&type=template&id=1d0d9c26"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/quentinpuechguiral/Documents/inProgress/patentidea.web3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__